// extracted by mini-css-extract-plugin
export default {"control":"CarsCheckoutComplete_control__JcPqn","row":"CarsCheckoutComplete_row__n9+5Q","col":"CarsCheckoutComplete_col__IfqEl"};